// src/components/Sidebar/Sidebar.js

import React from 'react';
import styles from './Sidebar.module.css';

const Sidebar = () => {
  return (
    <aside className={styles.sidebar}>
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Upcoming Events</h2>
        <ul className={styles.eventList}>
          <li>
          <img src="https://www.tourismtigrai.com/storage/f8Vmn0X7ZasoFfgnCe2grldRBOAEOkF5AZIICuNr.jpg" alt="Tourism Boost" />
            <div>
              <h3>Abalance potential tradeoffs, such as caching impacts. In this series, you’ll </h3>
              <p>Next week</p>
            </div>
          </li>
          <li>
          <img src="https://www.tourismtigrai.com/storage/hawiP43lSv7D0znHJb23IaxW1MnWfd3Cx0IzoUfu.jpg" alt="Addis Film Festival" />
            <div>
              <h3>Addis Film Festival</h3>
              <p>August 15-20, 2024</p>
            </div>
          </li>
        </ul>
      </section>
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Latest News</h2>
        <ul className={styles.newsList}>
          <li>
          <img src="https://www.tourismtigrai.com/storage/Xvv30tGL2KtkWsughczAojadmZ2JWvpKEA4niX6d.jpg" alt="Ashenda Events" />
            <div>
              <h3>Building container images is both technical and an art. You want to keep the image small and focused to increase your security posture, but also need to .</h3>
            </div>
          </li>
          <li>
          <img src="https://www.tourismtigrai.com/storage/f8Vmn0X7ZasoFfgnCe2grldRBOAEOkF5AZIICuNr.jpg" alt="Tourism Boost" />
            <div>
              <h3>Ethiopia Sees Significant Boost in Tourism</h3>
            </div>
          </li>
        </ul>
      </section>
    </aside>
  );
};

export default Sidebar;